<template>
  <div class="mall_banner_carousel" v-if="list.length">
    <swiper
      class="mall_banner_carousel_swiper"
      :options="swiper_option"
      ref="mallBannerSwiper"
    >
      <swiper-slide v-for="(item, index) of list" :key="slide_key(item, index)">
        <div class="slide_wrap">
          <img
            class="slide_img radius-8px"
            :src="item.img_path || item.imgPath"
            :style="slide_img_style(item)"
            alt=""
            @error="onImgError"
          />
          <div
            :path="
              (item.ad_target || item.adTarget || '') +
              (String(item.ad_target || item.adTarget || '').indexOf('?') >= 0 ? '&' : '?') +
              'sorce=8'
            "
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="is_wx && (item.ad_type == 7 || item.ad_type == 8 || item.adType == 7 || item.adType == 8)"
          ></div>
        </div>
      </swiper-slide>
    </swiper>
    <div
      class="swiper-pagination mall_banner_carousel_pagination f0"
      :id="pagination_id"
    ></div>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, checkAgent } from '../../../assets/common/js/config'
import adExposeMixin from '../js/adExposeMixin'

/**
 * 商城首页通用轮播（分类下等）：宽随容器，单张横向轮播，高由图片比例自适应。
 * 默认 3s 切换一张、loop、左滑方向与首页 banner 一致。
 */
export default {
  name: 'mallBannerCarousel',
  mixins: [adExposeMixin],
  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  props: {
    /** 与 bannerZone / 广告位结构一致：img_path、ad_type、ad_target 等 */
    list: {
      type: Array,
      default: () => []
    },
    /** 自动轮播间隔 ms，默认 3000 */
    autoplay_delay: {
      type: Number,
      default: 3000
    },
    /** 埋点 flowArea 前缀，如 bannerZone */
    flow_area_prefix: {
      type: String,
      default: 'bannerZone'
    }
  },
  data() {
    return {
      is_wx: isWeixin() ? 1 : 0,
      pagination_id: ''
    }
  },
  computed: {
    swiper_option() {
      const n = this.list.length
      const loop_enabled = n > 1
      var that = this
      return {
        loop: loop_enabled,
        slidesPerView: 1,
        slidesPerGroup: 1,
        speed: 400,
        autoplay: loop_enabled
          ? {
              delay: this.autoplay_delay,
              disableOnInteraction: false
            }
          : false,
        observer: true,
        observeParents: true,
        pagination: {
          el: '#' + this.pagination_id,
          type: 'bullets'
        },
        on: {
          slideChangeTransitionStart: function () {
            var el = that.$refs.mallBannerSwiper && that.$refs.mallBannerSwiper.$el
            that.notifyAdExposeCarouselHandle(el)
          },
          click: function () {
            var activeIndex = this.realIndex
            if (checkAgent() != 'Harmony') {
              that.bannerClickHandle(
                that.list[activeIndex],
                activeIndex
              )
            }
          }
        }
      }
    }
  },
  created() {
    this.pagination_id = 'mall-banner-pag-' + this._uid
  },
  mounted() {
    this.$nextTick(() => {
      this.swiperClickHandler('mallBannerSwiper')
      this.bindMallBannerExposeHandle()
    })
  },
  watch: {
    list: function () {
      this.scheduleAdExposeBindHandle(this.bindMallBannerExposeHandle)
    }
  },
  methods: {
    // swiper点击兼容鸿蒙系统
    swiperClickHandler(refName, ref_i) {
      const swiperEl =
        typeof ref_i == 'number' ? this.$refs[refName][ref_i].$el : this.$refs[refName].$el
      const eventType = checkAgent() == 'Harmony' ? 'click' : ''
      if (eventType) {
        swiperEl.addEventListener(eventType, (e) => {
          e.stopPropagation()
          const slideItem = e.target.closest('.swiper-slide')
          if (slideItem) {
            const id = slideItem.dataset.swiperSlideIndex
              ? parseInt(slideItem.dataset.swiperSlideIndex || 0)
              : parseInt(slideItem.getAttribute('data-swiper-slide-index') || 0)
            this.bannerClickHandle(
              this.list[id],
              id
            )
          }
        })
      }
    },
    slide_key(item, index) {
      return (item.ad_target || item.img_path || '') + '-' + index
    },
    slide_img_style(item) {
      const w = parseFloat(item.width)
      const h = parseFloat(item.height)
      if (w > 0 && h > 0) {
        return { aspectRatio: w + ' / ' + h }
      }
      return {}
    },
    onImgError(e) {
      const img = e.target
      img.src = '/static/images/errorimg.jpg'
      img.onerror = null
    },
    bannerClickHandle(item, index) {
      this.$emit('banner-click', item, index, this.flow_area_prefix + '-' + (index + 1))
    },
    bindMallBannerExposeHandle: function () {
      var that = this
      var comp = this.$refs.mallBannerSwiper
      if (!comp || !comp.$el || !this.list.length) return
      this.bindAdExposeCarouselHandle(comp.$el, {
        get_index: function () {
          if (comp.swiper && typeof comp.swiper.realIndex === 'number') return comp.swiper.realIndex
          return 0
        },
        get_item: function (idx) {
          return that.list[idx] || {}
        },
        make_key: function (idx) {
          return that.flow_area_prefix + '-' + (idx + 1)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.mall_banner_carousel {
  position: relative;
  overflow: hidden;
}

.mall_banner_carousel_swiper {
  width: 100%;
}

.slide_wrap {
  position: relative;
  display: block;
  width: 100%;
}

.slide_img {
  display: block;
  width: 100%;
  height: auto;
}

/* 与首页 index.vue #swiperBanner / #bannerSwiperPagination 指示点一致 */
/deep/ .mall_banner_carousel_pagination {
  bottom: 0.1rem !important;
  left: 0;
  right: 0;
  width: 100%;
  text-align: center;
  font-size: 0;
  span {
    margin-left: 0.05rem;
    &.swiper-pagination-bullet {
      width: 0.05rem;
      height: 0.05rem;
      border-radius: 50%;
      background: #ffffff;
      opacity: 1;
      vertical-align: middle;
    }
    &:first-child {
      margin-left: 0;
    }
    &.swiper-pagination-bullet-active {
      background: #fc0324;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/mallBannerCarousel.vue